const reportWebVitals = (onPerfEntry?: any) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    // Web vitals reporting disabled for now
    console.log('Web vitals reporting disabled');
  }
};

export default reportWebVitals; 